/**
 * RoleStatusBadge.jsx — Employer v1.1 Phase 0.6 Slice A.
 *
 * Single shared status badge for the widened R-24 vocabulary:
 *   draft · live (legacy alias) · active · closing · closed · archived
 *
 * `live` carries an extra "legacy" hint chip per pre-code plan §2.1.
 */
import { Badge } from '@/components/ui/badge';

const STATUS_TONE = {
  draft:    'bg-ndor-surface-alt  text-slate-200  border-slate-300',
  live:     'bg-emerald-500/10 text-emerald-200 border-emerald-500/40',
  active:   'bg-emerald-500/10 text-emerald-200 border-emerald-500/40',
  closing:  'bg-amber-500/10   text-amber-200   border-amber-500/40',
  closed:   'bg-rose-500/10    text-rose-200    border-rose-500/40',
  archived: 'bg-ndor-surface-alt   text-slate-200    border-zinc-300',
};

const STATUS_LABEL = {
  draft:    'Draft',
  live:     'Active',
  active:   'Active',
  closing:  'Closing',
  closed:   'Closed',
  archived: 'Archived',
};

export default function RoleStatusBadge({ status, dataTestid }) {
  const key  = (status || '').toLowerCase();
  const tone = STATUS_TONE[key]  || 'bg-ndor-surface-alt text-slate-300 border-slate-200';
  const text = STATUS_LABEL[key] || (status || 'Unknown');
  return (
    <span
      className="inline-flex items-center gap-2"
      data-testid={dataTestid || `role-status-${key}`}
    >
      <Badge className={`${tone} border`}>{text}</Badge>
      {key === 'live' ? (
        <span
          className="text-xs text-slate-300"
          data-testid="role-status-live-legacy-hint"
        >
          legacy
        </span>
      ) : null}
    </span>
  );
}
